import { Box, CircularProgress, Typography } from '@mui/material';

import { useUploaderContext } from '@/context/UploaderProvider';

export const ProcessingStep = () => {
  const { stepProcessing, uploadProgress } = useUploaderContext();

  return (
    <Box>
      <Typography sx={{ color: 'var(--tx-text)', fontSize: 24, fontWeight: 600, mb: '8px' }}>
        Building your Home HQ
      </Typography>
      <Typography sx={{ color: '#918d87', fontSize: 13, lineHeight: 1.65, mb: '26px', maxWidth: 520 }}>
        We're analyzing your inspection report. Your condition score and repair plan will unlock
        automatically.
      </Typography>

      <Box
        sx={{
          py: '34px',
          border: 0,
          background: 'var(--tx-fill)',
          borderRadius: '16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <CircularProgress
          variant={uploadProgress > 0 && uploadProgress < 100 ? 'determinate' : 'indeterminate'}
          value={uploadProgress}
          size={62}
          thickness={3}
          sx={{ color: '#c0ff02', mb: '18px' }}
        />
        <Typography sx={{ color: 'var(--tx-muted)', fontSize: 12 }}>
          {stepProcessing === 1 ? 'Uploading report…' : 'Analyzing your home…'}
        </Typography>
      </Box>
    </Box>
  );
};
